// the first thing we check if auth token is till valid, we can still set the auth state

/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import useAuthStore from "authClient/authStore";
import Strings from "toolbox/strings";

export default async function onLoad() {


    // Handle token from URL
    const params = new URLSearchParams(window.location.search);
    const refreshToken = params.get('refreshToken');

    if (!Strings.isEmpty(refreshToken)) {
        // Clean URL
        params.delete('refreshToken');
        const newUrl = window.location.pathname + (params.toString() ? '?' + params : '');
        window.history.replaceState({}, '', newUrl);
    }

    await useAuthStore.getState().initializeAuth(refreshToken)


}
